import { render, staticRenderFns } from "./list-calon.vue?vue&type=template&id=1d06488e&"
import script from "./list-calon.vue?vue&type=script&lang=js&"
export * from "./list-calon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-calon.vue"
export default component.exports